import { render, staticRenderFns } from "./QuizModalV2.vue?vue&type=template&id=6573def2&scoped=true&"
import script from "./QuizModalV2.vue?vue&type=script&lang=js&"
export * from "./QuizModalV2.vue?vue&type=script&lang=js&"
import style0 from "./QuizModalV2.vue?vue&type=style&index=0&id=6573def2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573def2",
  null
  
)

export default component.exports